import React from 'react'

import { TextInput } from '../text-input'
import { NumericInputProps } from './numeric-input.types'
import { processNumericValue } from './numeric-input.utils'

export const NumericInput = ({
  mode = 'integer',
  decimalPlaces = 2,
  min,
  max,
  value,
  onChange,
  ...props
}: NumericInputProps) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = processNumericValue(event.target.value, value, mode, decimalPlaces, min, max)
    onChange(newValue)
  }

  return (
    <TextInput
      type="text"
      inputMode={mode === 'decimal' ? 'decimal' : 'numeric'}
      value={value}
      onChange={handleChange}
      {...props}
    />
  )
}
